import { createServicesQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useServicesQuery = createServicesQuery(HTTP_CONFIG.API.Optimizely.url)
